var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"justify-center",attrs:{"dark":"","color":"primary"}},[_c('p',{staticClass:"ma-0 pa-1 text-center text-caption"},[_vm._v(" Data & Images provided by: "),_c('a',{staticClass:"accent--text",attrs:{"href":"https://www.themoviedb.org/","target":"_blank"}},[_vm._v("The Movie Database")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }